module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-144x144.13f7a1c1b42ff4732c6f8b6a5562ed1d.png";